<button nz-button nzType="link" (click)="openModal.set(true)">
  <span nz-icon nzType="user-switch"></span>
  <span>
    {{ 'shared.impersonate.title' | translate }}
  </span>
</button>

<nz-modal
  nzCentered
  nzMaskClosable="false"
  [nzTitle]="'shared.impersonate.title' | translate"
  [nzVisible]="openModal()"
  (nzOnCancel)="openModal.set(false)"
>
  <ng-container *nzModalContent>
    <form
      #form="ngForm"
      nz-form
      [formGroup]="impersonateUserForm"
      (ngSubmit)="onImpersonateUserSubmit()"
    >
      <p>
        {{ 'shared.impersonate.description' | translate }}
      </p>

      <nz-form-item>
        <nz-form-control [nzErrorTip]="'global.email' | translate">
          <nz-input-group nzPrefixIcon="user">
            <input
              nz-input
              formControlName="userId"
              [placeholder]="'global.email' | translate"
            />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>

  <ng-container *nzModalFooter>
    <button nz-button nzType="primary" (click)="ngForm().ngSubmit.emit()">
      {{ 'shared.impersonate.submitBtn' | translate }}
    </button>

    <button type="button" nz-button (click)="openModal.set(false)">
      {{ 'global.cancel' | translate }}
    </button>
  </ng-container>
</nz-modal>
